<template>
  <div>
    <v-skeleton-loader v-if="loading" type="list-item-avatar-three-line, article, article"></v-skeleton-loader>
    <v-card v-else-if="!retry">
      <v-card-title>
        <v-icon class="mr-3" color="primary">fa-building</v-icon>
        {{customer.Name}}
      </v-card-title>
      <v-card-text style="height:300px; overflow:auto">
        <div class="d-flex flex-wrap">
        <div class="mr-6">
          <image-uploader
            id="iu1"
            :preview="false"
            capture="environment"
            :quality="1"
            accept=".jpg, .png"
            :autoRotate="true"
            outputFormat="verbose"
            @input="setCustomerLogo"
          >
            <label for="iu1" slot="upload-label">
              <template v-if="customer.Logo">
                <v-img max-width="200" max-height="250" contain :src="(customer.Logo == null) ? emptyImage : customer.Logo"></v-img>
                <a class="primary--text">{{$t('changeLogo')}}</a>
              </template>
              <template v-else>
                <v-card class="ma-2 bg-grey" width="150" v-on="on" outlined height="150">
                  <v-container style="width:142px" fill-height>
                    <div class="mx-auto text-center">
                      <v-icon color="primary">add_photo_alternate</v-icon>
                      <a class="primary--text">{{$t('logo')}}</a>
                    </div>
                  </v-container>
                </v-card>

                <!-- <a class="primary--text">{{$t('addLogo')}}</a>
                <v-icon>add_photo_alternate</v-icon>-->
              </template>
            </label>
          </image-uploader>
        </div>
        <div class="mt-3">
          <p>
            {{customer.InvoiceAddress.Street}} {{customer.InvoiceAddress.StreetNumber}} {{customer.InvoiceAddress.StreetBox}}
            <br />
            {{customer.InvoiceAddress.Zipcode}} {{customer.InvoiceAddress.City}}
            <br />
            {{customer.InvoiceAddress.Country}}
            <br />
            {{customer.Phone}}
            <br />
            <!-- {{customer.Email}} -->
            <br />
            {{customer.Web}}
          </p>
        </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="saveCustomer">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
    <retry v-on:retry="getCustomer()" v-else></retry>
  </div>
</template>

<script>
import jwtdecode from "jwt-decode";
import { serviceihub } from "@/services/service.ihub.js";
const _serviceIhub = new serviceihub();
import retry from "@/components/Retry";
import storage from "@/components/pages/Users/Storage";
export default {
  components: {
    retry,
    storage
  },
  data() {
    return {
      emptyImage: require("@/assets/empty.png"),
      customer: null,
      retry: false,
      loading: false
    };
  },
  created() {
    this.getCustomer();
  },
  methods: {
    getCustomer() {
      this.loading = true;
      _serviceIhub
        .getCustomer(jwtdecode(localStorage.getItem("auth")).customerId)
        .then(res => {
          this.retry = false;
          this.customer = res.data;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.retry = true;
          console.log(err);
        });
    },
    setCustomerLogo(output) {
      this.customer.Logo = output.dataUrl;
    },
    saveCustomer() {
      if (this.customer) {
        _serviceIhub
          .updateCustomer(this.customer)
          .then(res => {
            this.$noty.success(this.$t("success"));
          })
          .catch(res => {
            this.$noty.error(this.$t("error"));
          });
      }
    }
  }
};
</script>

<style>
#iu1 {
  display: none;
}
</style>

<style scoped>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Users/Customer.vue